<!-- <p>linktotfs works!</p> -->
<!-- <a href="{{ ekSlideValue }}" title="Go To Link: {{ ekSlideValue }}" target="_blank" rel="noopener"
class="form-control textfield__input borderStyle" style="float: right"></a> -->
<img alt="TFS Link icon"
        src="../assets/icons/globe.svg" height="22" width="22" (click)="onLinkClick()" />